"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveHideRating = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
const resolveHideRating = async ({
  staticApiUrl,
  tenant,
  logger
}) => {
  const client = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl
  });
  try {
    const [bazaarvoiceConfig, testfreaksConfig] = await Promise.all([(0, _staticApiClientReact.getTenantBazaarvoiceConfiguration)(client, tenant), (0, _staticApiClientReact.getTenantTestfreaksConfiguration)(client, tenant)]);
    const {
      ratingsAndReviewsEnabled
    } = bazaarvoiceConfig.data;
    const {
      scriptUrl
    } = testfreaksConfig.data;
    return !ratingsAndReviewsEnabled && !scriptUrl;
  } catch (error) {
    if (logger) {
      logger.error(new Error('Failed getTenantBazaarvoiceConfiguration in resolveHideRating', {
        cause: error
      }));
    }
    return true;
  }
};
exports.resolveHideRating = resolveHideRating;
